<mat-form-field [appearance]="appearance" [class]="class" [dir]="dir" [floatLabel]="floatLabelType"
  (click)="onClick.emit($event)">
  @if (label) {
    <mat-label [dir]="dir" class="text-sm">{{ label }}</mat-label>
  }

  @if (prefixIcon) {
    <ng-icon matPrefix [dir]="dir" [name]="prefixIcon" [class]="prefixIconClass"></ng-icon>
  }

  <!--
    a11y: property binding [aria-describedby] (not [attr.]) lets MatInput's @Input fire so MatFormField
    keeps the error id when it re-syncs aria-describedby on the input host.

    Combobox-autocomplete-list pattern (WAI-ARIA APG): when `comboboxRole` is true, expose
    `role="combobox"`, `aria-autocomplete="list"`, `aria-controls`, `aria-expanded`, and
    `aria-activedescendant` so SR users hear "combobox, expanded, X of N option Y" while
    typing/arrowing. Parent owns the listbox DOM + keyboard navigation; this component
    only forwards the state.
  -->
  <input #inputElement matInput [type]="type" [class]="inputClass" [dir]="dir" [pattern]="pattern" [formControl]="formControl"
    (change)="onTextChange.emit($event)" [readonly]="readOnly" [placeholder]="placeholder" [ngStyle]="{'text-align': dir === 'rtl' ? 'right' : 'left'}"
    [aria-describedby]="(formControl.invalid && formControl.touched && displayErrors) ? errorId : null"
    [attr.aria-invalid]="(formControl.invalid && formControl.touched) ? 'true' : null"
    [attr.role]="comboboxRole ? 'combobox' : null"
    [attr.aria-autocomplete]="comboboxRole ? 'list' : null"
    [attr.aria-controls]="comboboxRole ? comboboxControlsId : null"
    [attr.aria-expanded]="comboboxRole ? (comboboxExpanded ? 'true' : 'false') : null"
    [attr.aria-activedescendant]="comboboxRole ? (comboboxActiveDescendant || null) : null"
    [attr.aria-label]="ariaLabel || null" />
    @if (icon) {
      <button
        matSuffix
        type="button"
        class="!min-w-0 !p-0 !border-0 !bg-transparent cursor-pointer"
        [attr.aria-label]="iconButtonAriaLabel"
        (click)="$event.stopPropagation(); onIconClick.emit($event)">
        <ng-icon [dir]="dir" [name]="icon" [class]="iconClass"></ng-icon>
      </button>
    }
  </mat-form-field>

  @if (formControl.invalid && formControl.touched && !!displayErrors) {
    <mat-error
      [id]="errorId"
      class="error"
      role="alert"
      aria-live="assertive"
      style="color: red; text-align: left">
      {{ getFirstError() }}
    </mat-error>
  }